/**
* @Description 文件功能说明：上传预览弹窗
* @Author 张彬
* @Time 2021/3/13 11:33
**/

/* HTML */
<template>
    <div v-if="dialogTreeItem.dialogFormVisible">
        <el-dialog :title="dialogTreeItem.title"
                   :visible.sync="dialogTreeItem.dialogFormVisible"
                   :close-on-click-modal="false"
                   custom-class="form-dialog"
                   v-dialogDrag
                   class="dialog_title"
                   @close="handleDialogClose"
        >
            <el-form :inline="true" :model="searchForm" ref="searchForm">
                <el-form-item>
                    <span >筛选条件：</span>
                </el-form-item>
                <el-form-item prop="keyword">
                    <el-input v-model="searchForm.keyword" placeholder="请输入标签编号/序号" clearable :style="{width: '300px'}">
                        <i slot="suffix" class="el-input__icon el-icon-search" @click="search"></i>
                    </el-input>
                </el-form-item>
                <el-form-item v-if="false" style="float: right;">
                    <el-button type="primary" class="el-icon-delete" size="mini" @click="completelyDelete"> 彻底清除</el-button>
                </el-form-item>
            </el-form>


            <!-- 表格 -->
            <DynamicTable ref="dynamicTable"
                          :previewTitle="previewTitle"
                          :previewData="searchResult"
                          :selectBox="true"
                          :optionButton="false"
                          @selectRow="selectRow"
                          @selectRows="selectRows"
                          :key="dynamicTableKey"
                          :showSerialNumber="showSerialNumber"
            />

            <el-form v-if="dialogTreeItem.submitButton != ''" style="margin-bottom: 10px;" ref="rowForm" :rules="rules" :model="rowForm">
                <el-form-item style="float: left;">
                    <div><span>已选中 </span><span style="font-weight: bold;">{{selectIds.length}}</span> <span>个</span></div>
                    <div v-if="selectIds.length>0"><span style="font-weight: bold;">选中：{{selectIds}}</span></div>
                </el-form-item>
                <el-form-item style="float: right; " prop="selectProjectId">
                    <el-select v-if="false" v-model="rowForm.selectProjectId" placeholder="请选择项目名称" clearable>
                        <el-option v-for="(value,key) in projectInfos" :key="key" :label="value.projectName" :value="key" ></el-option>
                    </el-select>
                    <el-button type="primary" @click.native="submit" size="mini">{{dialogTreeItem.submitButton}}</el-button>
                </el-form-item>
            </el-form>

        </el-dialog>
    </div>

</template>

/* JS */
<script>

import DynamicTable from '@/components/DynamicTable.vue'
// API oam
import ApiOam from '@/request/api-oam'

export default {

    /**
     * @Des 组件名
     * @Auth Zhangbin
     * @Date 17:22 2021/4/30
     */
    name: 'UwbTagAddDialog',

    /**
     * @Des 组件引用
     * @Auth Zhangbin
     * @Date 17:22 2021/4/30
     */
    components: {
        // 动态表格
        DynamicTable
    },

    /**
     * @Des 数据接收类型
     * @Auth Zhangbin
     * @Date 17:22 2021/4/30
     */
    props: {

        /**
         * @Des 标题数据类型
         * @Auth Zhangbin
         * @Date 17:23 2021/4/30
         */
        previewTitle: {
            type: Array,
            default: function (){
                return []
            }
        },

        /**
         * @Des 表格数据类型
         * @Auth Zhangbin
         * @Date 17:23 2021/4/30
         */
        previewData: {
            type: Array,
            default: function (){
                return []
            }
        },

        /**
         * @Des 上传地址类型
         * @Auth Zhangbin
         * @Date 17:23 2021/4/30
         */
        uploadUrl: {
            type: String,
            default: function (){
                return ''
            }
        },

        /**
         * @Des 是否显示序号
         * @Auth Zhangbin
         * @Date 17:23 2021/4/30
         */
        showSerialNumber: {
            type: Boolean,
            default: function (){
                return true
            }
        },

        /**
         * @Des 是否显示序号
         * @Auth Zhangbin
         * @Date 17:23 2021/4/30
         */
        projectInfos: {
            type: Object,
            default: function (){
                return {}
            }
        }
    },

    /**
     * @Des 数据定义
     * @Auth Zhangbin
     * @Date 17:23 2021/4/30
     */
    data() {
        return{

            /**
             * @Des 弹出层属性
             * @Auth Zhangbin
             * @Date 17:23 2021/4/30
             */
            dialogTreeItem: {
                title: '',
                dialogFormVisible: false,
                submitButton: '',
            },
            // 动态表格
            dynamicTableKey: 0,
            // 上传数据集合
            uploadData: [],
            // 选择的数量
            selectNum: 0,
            // 查询表单
            searchForm:{
                keyword: ""
            },
            // 查询结果
            searchResult: [],
            selectIds: [],
            operationLock: false,
            rowForm: {
                selectProjectId: this.$store.state.currentProjectId,
            },
            rules: {
                selectProjectId: [
                    { required: true, message: '请选择项目名称', trigger: 'blur' }
                ]
            }
        }
    },
    /**
     * @Des 监听
     * @Auth
     * @Date 2021/6/4
     */
    watch: {
        /**
         * @Des 分页监听
         * @Auth
         * @Date 2021/6/4
         */
        searchForm: {
            handler(newVal, oldVal){
                this.search();
            },
            immediate: true,
            deep:true,
        }
    },
    /**
     * @Des 方法定义
     * @Auth Zhangbin
     * @Date 17:24 2021/4/30
     */
    methods: {

        /**
         * 筛选查询
         * */
        search(){
            this.selectNum = 0;
            this.searchResult = [];
            if(this.searchForm.keyword == ''){
                this.searchResult = Object.assign([], this.previewData);
            }else{
                this.previewData.forEach((row, index) => {
                    if(row.shortId.indexOf(this.searchForm.keyword) != -1
                        || row.sid == this.searchForm.keyword
                    ){
                        if(this.selectIds.indexOf(row.id) == -1){
                            row.checked = false;
                        }else{
                            row.checked = true;
                        }
                        this.searchResult.push(row);
                    }
                })
            }
            this.dynamicTableKey++;
        },

        /**
         * @Des 打开弹窗
         * @Auth Zhangbin
         * @Date 17:24 2021/4/30
         */
        openDialog(title, button){
            this.dialogTreeItem.title = title;
            this.dialogTreeItem.dialogFormVisible = true;
            this.dialogTreeItem.submitButton = button;
            this.searchResult = [];
            this.selectIds = [];
            this.$nextTick(() => {
                this.searchResult = Object.assign([], this.previewData);
                this.$refs.dynamicTable.cleanSelect();
            })
        },

        /**
         * @Des 关闭弹窗
         * @Auth Zhangbin
         * @Date 17:24 2021/4/30
         */
        handleDialogClose(){
            this.$refs.dynamicTable.cleanSelect();
            this.dialogTreeItem.dialogFormVisible = false;
            this.$emit("research");
        },


        /**
         * @Des 选择行处理
         * @Auth Zhangbin
         * @Date 17:24 2021/4/30
         */
        selectRow(row, selection){
            // console.log(row, selection)
            this.selectNum = selection.length;
            this.resetSelectId(selection);
        },

        /**
         * @Des 选择多行处理
         * @Auth Zhangbin
         * @Date 17:24 2021/4/30
         */
        selectRows(rows){
            // console.log(rows);
            this.selectNum = rows.length;
            this.resetSelectId(rows);
        },

        /**
         * 重置选中的id
         * */
        resetSelectId(rows){
            // console.log(rows);
            // 新增id
            this.searchResult.forEach((r,i) => {
                let exist = false;
                rows.forEach((r2, i2) => {
                    if(r2.id == r.id){
                        exist = true;
                        if(this.selectIds.indexOf(r.id) == -1){
                            this.selectIds.push(r.id);
                            r.checked = true;
                        }
                    }
                });
                if(!exist){
                    if(this.selectIds.indexOf(r.id) != -1){
                        this.selectIds.splice(this.selectIds.indexOf(r.id),1);
                        r.checked = false;
                    }
                }
            })
        },

        /**
         * @Des 数据提交
         * @Auth Zhangbin
         * @Date 17:49 2021/4/30
         */
        submit(){
            if(this.selectIds.length == 0){
                this.$message({
                    message: '请选择数据',
                    type: 'info',
                    showClose: true,
                    dangerouslyUseHTMLString: true
                });
                return false;
            }
            if(this.uploadUrl == ''){
                this.$message({
                    message: '访问路径找不到！',
                    type: 'warning',
                    showClose: true,
                    dangerouslyUseHTMLString: true
                });
                return false;
            }
            this.$refs.rowForm.validate(valid => {
                if (!valid) return false;

                this.operationLock = true;
                this.$request.postJsonRequest(this.uploadUrl, {
                    sids: this.selectIds,
                    projectId: this.rowForm.selectProjectId
                }).then(result => {
                    if(result.code == 0){
                        this.$message({
                            message: '操作完成',
                            type: 'success',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                        this.handleDialogClose();
                        this.$emit("research");
                    }else{
                        this.$message({
                            message: result.msg,
                            type: 'error',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                    }
                    this.operationLock = false;
                }).catch(error => {
                	this.operationLock = false;
                    console.error('添加uwb标签异常', this.uploadUrl, error);
                });
            });
        },
        /**
         * @Des 数据删除
         * @Auth Zhangbin
         * @Date 17:49 2021/4/30
         */
        completelyDelete(){
            if(this.selectIds.length == 0){
                this.$message({
                    message: '请选择数据',
                    type: 'info',
                    showClose: true,
                    dangerouslyUseHTMLString: true
                });
                return false;
            }
            this.operationLock = true;
            this.$request.postJsonRequest(ApiOam.completelyDeleteApi, {
                sids: this.selectIds
            }).then(result => {
                if(result.code == 0){
                    this.$message({
                        message: '彻底删除成功',
                        type: 'success',
                        showClose: true,
                        dangerouslyUseHTMLString: true
                    });
                    this.handleDialogClose();
                    this.$emit("research");
                }else{
                    this.$message({
                        message: result.msg,
                        type: 'error',
                        showClose: true,
                        dangerouslyUseHTMLString: true
                    });
                }
                this.operationLock = false;
            }).catch(error => {
            	this.operationLock = false;
            	console.error('彻底删除uwb标签异常', ApiOam.completelyDeleteApi, error);
            });
        },
    },

}
</script>

/* CSS */
<style lang="scss" scoped>
	/deep/ .el-dialog {
		width: 90%;
	}
	/deep/ .form-dialog .el-select {
		width: auto;
	}
	/deep/ .form-dialog .el-form,
	/deep/ .form-dialog .el-form-item {
		margin-bottom: 0px;
	}
</style>



// WEBPACK FOOTER //
// src/components_pages/Device/UwbTagAddDialog.vue